var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "document_3_",
    "data-name": "document(3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.571,
    height: 44,
    viewBox: "0 0 34.571 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1538",
    "data-name": "Group 1538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1537",
    "data-name": "Group 1537",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M76.343,11a1.571,1.571,0,0,1-1.571-1.571V0H55.914A4.714,4.714,0,0,0,51.2,4.714V39.286A4.714,4.714,0,0,0,55.914,44H81.057a4.714,4.714,0,0,0,4.714-4.714V11Z",
    transform: "translate(-51.2)",
    fill: "#495057"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1540",
    "data-name": "Group 1540",
    transform: "translate(26.714 0.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1539",
    "data-name": "Group 1539",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M341.333,10v6.936h6.936Z",
    transform: "translate(-341.333 -10.001)",
    fill: "#495057"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachedIcon);
export default __webpack_public_path__ + "static/media/attached-icon.c8bf8ab732ce59b1cb3c1672a9d7b7f8.svg";
export { ForwardRef as ReactComponent };